import React from "react";

import "./AdminUsersList.css";
import { AdminUsersListItem } from "./AdminUsersListItem/AdminUsersListItem";
import { ListLoading } from "../../SharedComponents/ListLoading/ListLoading";

export const AdminUsersList = ({ title, users, loading }) => {
  return (
    <div className="AdminUsersList">
      <div className="AdminAccountsList__header">
        <div className="AdminAccountsList__title AdminAccountsList__name">
          {title[0]}
        </div>
        <div className="AdminAccountsList__title AdminAccountsList__status">
          {title[1]}
        </div>
        <div className="AdminAccountsList__title AdminAccountsList__info">
          {title[2]}
        </div>
        <div className="AdminAccountsList__end-padder"></div>
      </div>
      <div className="AdminUsersList__list">
        {loading && <ListLoading />}
        {!loading &&
          users.map((user) => <AdminUsersListItem user={user} key={user.id} />)}
      </div>
    </div>
  );
};
